<div class="row my-2">
  <div class="col-12">
    <h4 class="home-collapsible-title mb-1">
      <love-it-generic-icon [selector]="item.icon"></love-it-generic-icon>
      {{ item.title }}
    </h4>
  </div>
  @for (child of item.children; track child.id) {
    <div class="home-card-column">
      @if (checkPermission(child)) {
        <app-home-card
          [item]="child"
          [ngClass]="{
            'hide-mobile': !child.aufHandyAnzeigen,
          }"></app-home-card>
      }
    </div>
  }
</div>
